import {
  getTags,
  getTagsUserSubmission,
  resetFilter,
  getTagSelection,
} from 'reduxpath/ducks/Tag/List'

import Home from 'units/TopicsManagement'

const list = (store) => {
  store.dispatch(
    getTags(),
  )

  store.dispatch(
    getTagsUserSubmission(),
  )

  store.dispatch(getTagSelection({
    limit: 100,
    skip: 0,
  }))

  store.dispatch(resetFilter())
}

export default {
  populate: {
    list,
  },
  components: {
    Home,
  },
}
